<template>
  <FormRow :label="label" :helpTip="helpTip" :labelColumnSize="hideLabel ? 0 : 2">
    <div class="row">
      <div class="col-lg-3">
        <FormSelect v-if="editing" :options="filterTypeLookup" :value="filterTypeSetting" @input="filterTypeUpdated($event)" :field="field" />
        <FormStaticLabel v-if="!editing" class="font-weight-bold">{{filterTypeSetting | formatLookupName(filterTypeLookup)}}</FormStaticLabel>
      </div>
      <div class="col-lg-9">
        <FormMultiSelect v-show="editing && displayValue" :value="filterValueSetting" @input="filterValueUpdated($event)" :options="options" :field="field" />
        <FormStaticLabel v-if="!editing && displayValue">{{filterValueDisplay}}</FormStaticLabel>
      </div>
    </div>
  </FormRow>
</template>

<script>
import { FilterOptionTypes } from '@/store/types'

export default {
  name: 'FormUpdateFilter',
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    editing: Boolean,
    label: String,
    hideLabel: {
      type: Boolean,
      default: false
    },
    value: Object,
    options: Array,
    field: String,
    helpTip: String
  },
  watch: {
    value: function() {
      if(this.value) {
        this.filterTypeSetting = this.value.type
        this.filterValueSetting = this.value.valueList || []
        this.filterDescriptionSetting = this.value.descriptionList || []

        if(this.filterTypeSetting == null || this.filterTypeSetting == '')
          this.filterTypeSetting = FilterOptionTypes.all
      }
    }
  },
  computed: {
    displayValue() {
      return this.filterTypeSetting != FilterOptionTypes.all && this.filterTypeSetting != FilterOptionTypes.none
    },
    filterValueDisplay() {
      if(!this.filterValueSetting)
        return ''
      return this.filterValueSetting
      .map(value => {
        let lookupOpt = this.options.find(opt => opt.value == value)
        if(lookupOpt)
          return lookupOpt.name
        return ''
      })
      .join(', ')
    }
  },
  data() {
    return {
      filterTypeSetting: FilterOptionTypes.all,
      filterValueSetting: [],
      filterDescriptionSetting: [],
      filterTypeLookup: [
        { value: FilterOptionTypes.all, name: 'All' },
        { value: FilterOptionTypes.include, name: 'Include' },
        { value: FilterOptionTypes.exclude, name: 'Exclude' },
        { value: FilterOptionTypes.none, name: 'None' },
      ],
    }
  },
  methods: {
    filterTypeUpdated(type) {
      this.filterTypeSetting = type
      this.$emit('update', {
        type: this.filterTypeSetting,
        valueList: this.filterValueSetting,
        descriptionList: this.filterDescriptionSetting
      })
    },
    filterValueUpdated(value) {
      this.filterValueSetting = value
      let optionList = this.options || []
      this.filterDescriptionSetting = (value || []).map(item => {
        let optionItem = optionList.find(option => item == option.value)
        if(optionItem)
          return optionItem.name
        return ''
      })

      this.$emit('update', {
        type: this.filterTypeSetting,
        valueList: this.filterValueSetting,
        descriptionList: this.filterDescriptionSetting
      })
    }
  }

}
</script>